import dynamic, { DynamicOptions } from 'next/dynamic'
import { logger } from '@/utils/logging'

export const CheckoutLegalTermsExperiment = dynamic(
  import('./CheckoutLegalTermsExpComponent')
    .then((mod) => mod.CheckoutLegalTermsExpComponent)
    .catch((err) =>
      logger().error('Failed to load dynamic component', { component: 'CheckoutLegalTermsExpComponent' }, err),
    ) as DynamicOptions<Record<string, never>>,
  { ssr: false },
)
